import React from 'react'
import HalfHeroModuleWithForm from './HalfHeroModuleWithForm/HalfHeroModuleWithForm'
import HeroModuleFull from './HeroModuleFull/HeroModuleFull'
import HeroModuleHalf from './HeroModuleHalf/HeroModuleHalf'

export function HeroModule(props) {
  const hasSearchForm = props.searchForms ? true : false

  if (props?.columnDisplayOptions === '100') {
    return <HeroModuleFull {...props} />
  } else {
    return hasSearchForm ? <HalfHeroModuleWithForm {...props} /> : <HeroModuleHalf {...props} />
  }
}
